const Contact = () => {
    return (
        <div>
            <h1>These are my details to Contact Me</h1>
            <h2>Ring Me</h2>
        </div>
    )
}

export default Contact;